import React, { useEffect, useMemo, useState } from 'react'
import Select from 'react-select';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getAllData, postUsersData, verifytoken } from '../../services/ApiCallingUserServices';
import { alphaNumeric, alphaNumericspace, isValidEmail, onlyAlphabets, onlyNumeric } from '../../components/commonClass/CommonValidation';
import { ClearLocalStorage, GetLocalStorage } from '../../components/commonClass/Session';
import { loaderActions } from '../../_actions/loader.actions';
import dayjs from 'dayjs';
import { DatePicker } from 'antd';
import { userrights } from '../../components/commonClass/CommonInterfaceTypes';

const CreateTravelerProfile = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((store: any) => store.userstatus.tba);
  const menuItem = useSelector((store: any) => store.menuitems.menu);
  const [formErrors, setFormErrors] = useState<any>({});
  const [buttonaddeditText, setButtonAddEditText] = useState("Add");
  const [editdisabled, setEditDisabled] = useState(false);
  const [disable, setDisabled] = useState(false);
  const [countryStateCity, setCountryStateCity] = useState([])
  const [genderlist, setGenderList] = useState([])
  const [citylist, setCityList] = useState([])
  const [CountryId, setCountryId] = useState(1)
  const [userRights, setUserRights] = useState<userrights>();
  const [formdata, setFormDate] = useState({
    UserMasterId: 0,
    UserEmail: '',
    ContactNo: '',
    Firstname: '',
    MiddleName: '',
    LastName: '',
    CountryId: 1,
    DateOfBirth: '',
    LocationId: 0,
    GenderId: 0,
    PassportNumber: '',
    PermanentAddress: '',
    TemporaryAddress: '',
    TravelerId: '',
    IsOnline: false,
    IsOnlineLabel: "",
    UserType: 1,
    UserId: 0,
  })
  function formatDate(date: any) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }
  function calculateAge(birthDate: any) {
    const birthDateage = dayjs(birthDate);
    const today = dayjs();
    return today.diff(birthDateage, 'year'); // Calculate age in years
  }

  const getcountrystatecity = async () => {
    let statusoftoken = await verifytoken();
    if (statusoftoken) {
      await getAllData('/midoffice/v1/getcountrystatecity').then((data) => {
        setCountryStateCity(data?.data?.countryData?.map((el: any) => ({
          // label: el.ISDCode + ' ' + '(' + el.CountryName + ')',
          label: el.ISDCode,
          name: el.CountryName,
          value: el.CountryId,
          Code: el.ISDCode
        })))
        setGenderList(data?.data?.genderData?.map((el: any) => ({
          label: el.Gender,
          value: el.GenderId
        })))
        setCityList(data?.data?.cityData?.map((el: any) => ({
          label: el.City,
          value: el.LocationId,
          StateId: el.StateId,
          CountryId: el.CountryId

        })))
      })
    }
    else {
      ClearLocalStorage();
      dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
    }
    dispatch(loaderActions.end());

  }
  const gettravelerprofilebyid = async (id: any) => {
    let statusoftoken = await verifytoken();
    if (statusoftoken) {
      await getAllData('/midoffice/v1/gettravelerprofilebyid?userMasterId=' + id).then((data) => {
        setFormDate({
          ...formdata,
          UserMasterId: id,
          UserEmail: data?.data?.UserEmail,
          ContactNo: data?.data?.ContactNo,
          Firstname: data?.data?.Firstname,
          MiddleName: data?.data?.MiddleName,
          LastName: data?.data?.LastName,
          CountryId: data?.data?.CountryId,
          DateOfBirth: data?.data?.DateOfBirth,
          LocationId: data?.data?.LocationId,
          GenderId: data?.data?.GenderId,
          PassportNumber: data?.data?.PassportNumber,
          PermanentAddress: data?.data?.PermanentAddress,
          TemporaryAddress: data?.data?.TemporaryAddress,
          UserType: 1,
          IsOnline: data?.data?.IsOnline,
          IsOnlineLabel: data?.data?.IsOnlineLabel,
          TravelerId: data?.data?.TravelerId,
        })
        setCountryId(data?.data?.CountryId)
      })
      setButtonAddEditText('Update')
    }
    else {
      ClearLocalStorage();
      dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
    }
  }

  const CityOptions = useMemo(() => citylist?.filter((city: any) => city?.CountryId === formdata?.CountryId), [formdata?.CountryId, citylist]);

  const onChange = (name: any, val: any) => {
    setFormErrors({});
    setFormDate({ ...formdata, [name]: val });
    setEditDisabled(false);
  }
  const onDropdownChanage = (val: any, name: any) => {
    if (name?.name === 'CountryId') {
      setCountryId(val?.value)
      setFormDate({ ...formdata, [name?.name]: val?.value, LocationId: 0, PassportNumber: val?.value === 1 ? '' : formdata?.PassportNumber });
    }
    else {
      setFormDate({ ...formdata, [name?.name]: val?.value });
    }
    setFormErrors({});
    setEditDisabled(false);
  }
  const onChangeDate = (name: any, val: any) => {
    setFormErrors({});
    setFormDate({ ...formdata, DateOfBirth: name !== null ? formatDate(name) + 'T00:00:00' : "" });
    setEditDisabled(false);
  }

  const validateData = () => {
    var passportregex = new RegExp("^[a-zA-Z0-9 ]{6,9}$");
    let error: any = {};
    let status = true;
    if (formdata?.Firstname?.trim()?.length === 0) {
      error.Firstname = "Please Enter First Name.";
      status = false;
    }
    if (formdata?.Firstname && formdata?.Firstname?.trim()?.length < 2) {
      error.Firstname = "Please enter valid Name.";
      status = false;
    }
    if (formdata?.LastName?.trim()?.length === 0) {
      error.LastName = "Please Enter Last Name.";
      status = false;
    }
    if (formdata?.LastName && formdata?.LastName?.trim()?.length < 2) {
      error.LastName = "Please enter valid Name.";
      status = false;
    }
    if (formdata?.UserEmail?.trim()?.length === 0) {
      error.UserEmail = "Please Enter Email Id.";
      status = false;
    }
    else if (formdata.UserEmail?.trim()?.length > 0 && !isValidEmail(formdata?.UserEmail)) {
      error.UserEmail = "Please Enter Correct Email Id.";
      status = false;
    }
    if (formdata?.CountryId === 0) {
      error.CountryId = "Kindly Select Country Code.";
      status = false;
    }
    if (formdata?.ContactNo?.trim()?.length <= 0) {
      error.ContactNo = 'Please Enter Mobile Number.';
      status = false;
    }
    else if (formdata?.ContactNo?.trim()?.length < 5 || formdata?.ContactNo?.trim()?.length > 20) {
      error.ContactNo = 'Please Enter Valid Mobile Number.';
      status = false;
    }
    if (formdata?.DateOfBirth?.trim()?.length === 0) {
      error.DateOfBirth = "Kindly Enter Date Of Birth.";
      status = false;
    }
    if (formdata?.GenderId === 0) {
      error.GenderId = "Please select Gender";
      status = false;
    }
    if (formdata?.LocationId === 0 && formdata?.CountryId !== 0) {
      error.LocationId = "Kindly Select City.";
      status = false;
    }
    if (formdata?.PassportNumber?.trim()?.length === 0 && formdata?.CountryId !== 1) {
      error.PassportNumber = 'Please Enter Passport Number.'
      status = false;
    }
    else if (formdata?.PassportNumber?.trim()?.length > 0 && passportregex.test(formdata?.PassportNumber) === false) {
      error.PassportNumber = "Kindly Enter Correct Passport Number.";
      status = false;
    }
    if (formdata?.PermanentAddress?.trim()?.length === 0) {
      error.PermanentAddress = 'Please Enter Permanent Address.'
      status = false;
    }
    setFormErrors(error);
    return status;

  }
  const handlesavadata = async () => {
    if (!validateData()) {
      return;
    }
    else {
      let statusoftoken = await verifytoken();
      if (statusoftoken) {
        let token: any = GetLocalStorage();
        formdata.UserId = token?.userMasterID
        let status = false;
        const Data = await postUsersData("/midoffice/v1/inserupdatetravelerprofile", formdata);
        status = Data?.status;
        if (status) {
          setFormErrors({});
          dispatch({ type: 'ALERTINGMESSAGE', message: Data.message })
          clearData();
        }
        else {
          dispatch({ type: 'ALERTING', message: Data.message })
          return;
        }
      }
      else {
        ClearLocalStorage();
        dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
      }
    }

  }
  const clearData = () => {
    setButtonAddEditText("Add")
    setFormErrors({});
    setCountryId(1)
    setFormDate({
      ...formdata,
      UserMasterId: 0,
      UserEmail: '',
      ContactNo: '',
      Firstname: '',
      MiddleName: '',
      LastName: '',
      CountryId: 1,
      DateOfBirth: '',
      LocationId: 0,
      GenderId: 0,
      PassportNumber: '',
      PermanentAddress: '',
      TemporaryAddress: '',
      UserType: 1,
      IsOnline: false,
      IsOnlineLabel: "",
    })
    setEditDisabled(false);
  }


  useEffect(() => {
    dispatch(loaderActions.start());
    if (location?.state) {
      if (location?.state?.Id > 0) {
        gettravelerprofilebyid(location?.state?.Id)
      }
      setEditDisabled(location?.state?.editdisabled)
      setDisabled(location?.state?.disabled)
    }
    getcountrystatecity();
  }, [])

  //#region handle rights
  useEffect(() => {
    //check for rights
    if (user) {
      const pathname = window?.location?.pathname?.toLowerCase();
      const hasRights: userrights = user?.find((fil: any) => fil?.PageLink?.toLowerCase() === pathname)
      setUserRights(hasRights)
      if (!hasRights?.URightView) {
        navigate('/dashboard');
      }
    }
  }, [user]);
  //#endregion

  const customStyles = {
    menu: (provided: any) => ({
      ...provided,
      width: 'auto', // Set your desired width here
    })
  };

  // Format dropdown and selected value
  const formatOptionLabel = ({ label, name }: any, { context }: any) => {
    // Show label + name in the menu, only label in single value (selected)
    if (context === 'menu') {
      return (
        <div>
          {label} {name}
        </div>
      );
    }

    return <span>{label}</span>; // When selected
  };


  return (
    <>
      <div className="mx-2 mt-0 mb-3 heading_color">
        <h2 className='fw-bold'>{menuItem?.[1]?.pageTitle}</h2>
      </div>
      <div className="m-2 heading_color">
        <h4>{menuItem?.[2]?.pageTitle}</h4>
      </div>
      <div className="m-2">
        <form action="" className='mt-3'>
          <div className="mb-3 row mx-1">

            <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
              <div className="row">
                <div className="col-lg-4 col-md-12 col-sm-12">
                  <label htmlFor="Firstname" className="col-form-label required">First Name</label>
                </div>
                <div className=" col-lg-8 col-md-12 col-sm-12">
                  <input type="text" id="Firstname" className="form-control"
                    name="Firstname"
                    maxLength={25}
                    value={formdata?.Firstname}
                    onChange={(e: any) =>
                      e?.target?.value?.length <= 25 &&
                      onChange(e?.target?.name, onlyAlphabets(e?.target?.value))
                    }
                    disabled={disable}
                    placeholder="First Name"
                  />
                  {formErrors?.Firstname && <div className='text-danger text-start fs_14'>{formErrors?.Firstname}</div>}
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
              <div className="row">
                <div className="col-lg-4 col-md-12 col-sm-12">
                  <label htmlFor="MiddleName" className="col-form-label">Middle Name</label>
                </div>
                <div className=" col-lg-8 col-md-12 col-sm-12">
                  <input type="text" id="MiddleName" className="form-control"
                    name="MiddleName"
                    maxLength={20}
                    value={formdata?.MiddleName}
                    onChange={(e: any) => onChange(e?.target?.name, onlyAlphabets(e?.target?.value))}
                    disabled={disable}
                    placeholder="Middle Name"
                  />
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
              <div className="row">
                <div className="col-lg-4 col-md-12 col-sm-12">
                  <label htmlFor="LastName" className="col-form-label required">Last Name</label>
                </div>
                <div className=" col-lg-8 col-md-12 col-sm-12">
                  <input type="text" id="LastName" className="form-control"
                    name="LastName"
                    maxLength={25}
                    value={formdata?.LastName}
                    onChange={(e: any) =>
                      e?.target?.value?.length <= 25 &&
                      onChange(e?.target?.name, onlyAlphabets(e?.target?.value))
                    }
                    disabled={disable}
                    placeholder="Last Name"
                  />
                  {formErrors?.LastName && <div className='text-danger text-start fs_14'>{formErrors?.LastName}</div>}
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
              <div className="row">
                <div className="col-lg-4 col-md-12 col-sm-12">
                  <label htmlFor="UserEmail" className="col-form-label required">Email Id</label>
                </div>
                <div className=" col-lg-8 col-md-12 col-sm-12">
                  <input type="text" id="UserEmail" className="form-control"
                    name="UserEmail"
                    maxLength={150}
                    value={formdata.UserEmail}
                    onChange={(e: any) => onChange(e?.target?.name, e?.target?.value)}
                    disabled={disable}
                    placeholder="Email Id"
                  />
                  {formErrors?.UserEmail && <div className='text-danger text-start fs_14'>{formErrors?.UserEmail}</div>}
                </div>
              </div>
            </div>

            {/* <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
              <div className="row">
                <div className="col-lg-4 col-md-12 col-sm-12">
                  <label htmlFor="CountryId" className="col-form-label required">Country Code</label>
                </div>
                <div className=" col-lg-8 col-md-12 col-sm-12">
                  <Select
                    id='CountryId'
                    name='CountryId'
                    className="dropdown select_dropdown custom_class"
                    options={countryStateCity}
                    value={countryStateCity?.filter((data: any) => {
                      return data.value === formdata?.CountryId;
                    })}
                    isSearchable
                    onChange={onDropdownChanage}
                    isDisabled={disable}
                  />
                  {formErrors?.CountryId && <div className='text-danger text-start fs_14'>{formErrors?.CountryId}</div>}
                </div>
              </div>
            </div> */}

            <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
              <div className="row">
                <div className="col-lg-4 col-md-12 col-sm-12">
                  <label htmlFor="ContactNo" className="col-form-label required">Mobile Number</label>
                </div>
                <div className=" col-lg-8 col-md-12 col-sm-12">
                  <div className="input-group">
                    <span className="input-group-text py-0" id="basic-addon1" style={{ width: '130px', textAlign: 'left' }} >
                      {/* {countryStateCity?.filter((data: any) => data?.value === formdata?.CountryId)?.map((el: any) => el?.Code)} */}
                      <Select
                        id='CountryId'
                        name='CountryId'
                        className="dropdown select_dropdown custom_class mobile_code w-100"
                        options={countryStateCity}
                        value={countryStateCity?.filter((data: any) => {
                          return data.value === formdata?.CountryId;
                        })}
                        styles={customStyles}
                        formatOptionLabel={formatOptionLabel}
                        getOptionLabel={(country: any) => `${country.label} ${country.name}`}
                        isSearchable
                        onChange={onDropdownChanage}
                        isDisabled={disable}
                      />
                    </span>
                    <input className="form-control" id='ContactNo' type="text"
                      name="ContactNo"
                      maxLength={10}
                      value={formdata?.ContactNo}
                      onChange={(e: any) => onChange(e?.target?.name, onlyNumeric(e?.target?.value))}
                      disabled={disable}
                      placeholder="Mobile Number"
                    />
                  </div>
                  {formErrors?.ContactNo && <div className='text-danger text-start fs_14'>{formErrors?.ContactNo}</div>}
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
              <div className="row">
                <div className="col-lg-4 col-md-12 col-sm-12">
                  <label htmlFor="DateofBirth" className="col-form-label required">Date of Birth</label>
                </div>
                <div className=" col-lg-8 col-md-12 col-sm-12">
                  <DatePicker
                    id='DateofBirth'
                    className='form-control antd_field'
                    format={'DD-MM-YYYY'}
                    placeholder='dd-mm-yyyy'
                    maxDate={dayjs(new Date())}
                    value={formdata?.DateOfBirth ? dayjs(new Date(formdata?.DateOfBirth)) : ''}
                    onChange={onChangeDate}
                    disabled={disable}
                  />
                  {formErrors?.DateOfBirth && <div className='text-danger text-start fs_14'>{formErrors?.DateOfBirth}</div>}
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
              <div className="row">
                <div className="col-lg-4 col-md-12 col-sm-12">
                  <label htmlFor="Nationality" className="col-form-label">Nationality</label>
                </div>
                <div className=" col-lg-8 col-md-12 col-sm-12">
                  <input type="text" id="Nationality" className="form-control"
                    name="Nationality"
                    value={countryStateCity?.filter((data: any) => data?.value === formdata?.CountryId)?.map((el: any) => el?.name)}
                    maxLength={30}
                    // onChange={onChange}
                    disabled
                    placeholder="Nationality"
                  />
                  {/* {formErrors.UserName && <p className='text-danger text-start fs_14'>{formErrors.UserName}</p>} */}
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
              <div className="row">
                <div className="col-lg-4 col-md-12 col-sm-12">
                  <label htmlFor="genderid" className="col-form-label required">Gender</label>
                </div>
                <div className=" col-lg-8 col-md-12 col-sm-12">
                  <Select
                    id='genderid'
                    className="dropdown select_dropdown custom_class"
                    options={genderlist}
                    value={genderlist?.filter(function (genderlist: any) {
                      return genderlist.value === formdata?.GenderId;
                    })}
                    name='GenderId'
                    isSearchable
                    onChange={onDropdownChanage}
                    isDisabled={disable}
                  />
                  {formErrors?.GenderId && <div className='text-danger text-start fs_14'>{formErrors?.GenderId}</div>}
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
              <div className="row">
                <div className="col-lg-4 col-md-12 col-sm-12">
                  <label htmlFor="UserName" className="col-form-label required">Age</label>
                </div>
                <div className=" col-lg-8 col-md-12 col-sm-12">
                  <input type="text" id="UserName" className="form-control"
                    name="Age"
                    value={formdata?.DateOfBirth !== '' ? calculateAge(formdata?.DateOfBirth) : ''}
                    maxLength={30}
                    // onChange={onChange}
                    disabled
                    placeholder="Age"
                  />
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
              <div className="row">
                <div className="col-lg-4 col-md-12 col-sm-12">
                  <label htmlFor="LocationId" className="col-form-label required">City</label>
                </div>
                <div className=" col-lg-8 col-md-12 col-sm-12">
                  <Select
                    className="dropdown select_dropdown custom_class"
                    options={CityOptions}
                    id='LocationId'
                    value={CityOptions?.filter((data: any) => {
                      return data.value === formdata?.LocationId;
                    })}
                    name='LocationId'
                    onChange={onDropdownChanage}
                    isDisabled={formdata?.CountryId ? disable ? true : false : true}
                    isSearchable={true}
                  />
                  {formErrors?.LocationId && <div className='text-danger text-start fs_14'>{formErrors?.LocationId}</div>}
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
              <div className="row">
                <div className="col-lg-4 col-md-12 col-sm-12">
                  <label htmlFor="PassportNumber" className="col-form-label required">Passport Number</label>
                </div>
                <div className=" col-lg-8 col-md-12 col-sm-12">
                  <input type="text" id="PassportNumber" className="form-control"
                    name="PassportNumber"
                    value={formdata?.PassportNumber}
                    maxLength={9}
                    onChange={(e: any) => onChange(e?.target?.name, alphaNumeric(e?.target?.value))}
                    disabled={formdata?.CountryId !== 1 ? disable ? true : false : true}
                    placeholder="Passport Number"
                  />
                  {formErrors?.PassportNumber && <div className='text-danger text-start fs_14'>{formErrors?.PassportNumber}</div>}
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
              <div className="row">
                <div className="col-lg-4 col-md-12 col-sm-12">
                  <label htmlFor="PermanentAddress" className="col-form-label required">Permanent Address</label>
                </div>
                <div className=" col-lg-8 col-md-12 col-sm-12">
                  <input type="text" id="PermanentAddress" className="form-control"
                    name="PermanentAddress"
                    value={formdata?.PermanentAddress}
                    maxLength={250}
                    onChange={(e: any) => onChange(e?.target?.name, alphaNumericspace(e?.target?.value))}
                    disabled={disable}
                    placeholder="Permanent Address"
                  />
                  {formErrors?.PermanentAddress && <div className='text-danger text-start fs_14'>{formErrors?.PermanentAddress}</div>}
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
              <div className="row">
                <div className="col-lg-4 col-md-12 col-sm-12">
                  <label htmlFor="TemporaryAddress" className="col-form-label">Temporary Address</label>
                </div>
                <div className=" col-lg-8 col-md-12 col-sm-12">
                  <input type="text" id="TemporaryAddress" className="form-control"
                    name="TemporaryAddress"
                    value={formdata?.TemporaryAddress}
                    maxLength={250}
                    onChange={(e: any) => onChange(e?.target?.name, alphaNumericspace(e?.target?.value))}
                    disabled={disable}
                    placeholder="Temporary Address"
                  />
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
              <div className="row">
                <div className="col-lg-4 col-md-12 col-sm-12">
                  <label htmlFor="TravelerId" className="col-form-label">Traveler Id</label>
                </div>
                <div className=" col-lg-8 col-md-12 col-sm-12">
                  <input type="text" id="TravelerId" className="form-control"
                    name="TravelerId"
                    // maxLength={20}
                    value={formdata?.TravelerId}
                    onChange={(e: any) => onChange(e?.target?.name, e?.target?.value)}
                    disabled
                    placeholder="Traveler Id"
                  />
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-6 col-sm-12 mb-1">
              <div className="row">
                <div className="col-lg-4 col-md-12 col-sm-12">
                  <label htmlFor="Source" className="col-form-label">Source</label>
                </div>
                <div className=" col-lg-8 col-md-12 col-sm-12">
                  <input type="text" id="Source" className="form-control"
                    name="Source"
                    value={formdata?.IsOnlineLabel}
                    onChange={(e: any) => onChange(e?.target?.name, e?.target?.value)}
                    disabled
                    placeholder="Source"
                  />
                </div>
              </div>
            </div>

          </div>
          <div className="d-flex justify-content-center">
            {userRights?.URightAdd === false && buttonaddeditText === "Add" ?
              <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handlesavadata} disabled={!userRights?.URightAdd}>{buttonaddeditText} Profile</button> :
              <button type="button" className="btn btn-primary mx-1" onClick={handlesavadata} disabled={(userRights?.URightEdit || buttonaddeditText === 'Add') ? editdisabled : !userRights?.URightEdit} id="btnAdd" >{buttonaddeditText} Profile</button>}
            <button type="button" className="btn btn-primary mx-1" disabled={disable} onClick={clearData} id="btnClear" >Clear</button>
            <button type="button" className="btn btn-primary mx-1" onClick={() => navigate('/travelerprofilelist')} id="btnClear" >Back</button>
          </div>
          <br />
        </form>
      </div>
    </>
  )
}

export default CreateTravelerProfile